"use client";

import type { ReactNode } from "react";
import { UploadProvider } from "@/components/upload/UploadProvider";
import { MagazineUploadProvider } from "@/components/upload/MagazineUploadProvider";
import { ThumbnailJobProvider } from "@/components/upload/ThumbnailJobProvider";
import { UploadTray } from "@/components/upload/UploadTray";

export function UploadShell({
  children,
  isAdmin,
  userId,
}: {
  children: ReactNode;
  isAdmin: boolean;
  userId?: string | null;
}) {
  return (
    <UploadProvider userId={userId}>
      <MagazineUploadProvider userId={userId}>
        <ThumbnailJobProvider userId={userId}>
          {children}
          <UploadTray isAdmin={isAdmin} />
        </ThumbnailJobProvider>
      </MagazineUploadProvider>
    </UploadProvider>
  );
}
